
        <button type="button" (click)="navigateBack()">
            <span>
                <i></i>
                <span i18n="@@PopoversBackClose">Close</span>
            </span>
        </button>
    